export default {
  mainContainer: {
    background: '#eaecf0',
    display: 'table',
    clear: 'both',
    width: '100%'
  }
}
